import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import {
  ICampaignGroupsPayload,
  ICampaignGroupsResponse,
  ICampaignGroupResponse,
  ICampaignGroupStats,
  ICampaignGroupData,
  ISearchCampaignsResponse
} from '@/apps/traforama/interfaces/campaignGroups'

export const fetchItems = async (
  payload: ICampaignGroupsPayload
): Promise<ICampaignGroupsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    payload.filter ? nestedQueryFormatter('filter', payload.filter, false) : {}
  )
  const response = await apiClient.get<ICampaignGroupsResponse>(
    '/campaign_groups',
    { params }
  )
  return response.data
}

export const fetchItem = async (
  id: string
): Promise<ICampaignGroupResponse> => {
  const response = await apiClient.get<ICampaignGroupResponse>(
    `/campaign_groups/${id}`
  )
  return response.data
}

export const createItem = async (
  data: ICampaignGroupData
): Promise<ICampaignGroupResponse> => {
  const response = await apiClient.post<ICampaignGroupResponse>(
    '/campaign_groups',
    data
  )
  return response.data
}

export const updateItem = async (
  id: number,
  data: ICampaignGroupData
): Promise<ICampaignGroupResponse> => {
  const response = await apiClient.put<ICampaignGroupResponse>(
    `/campaign_groups/${id}`,
    data
  )
  return response.data
}

export const destroyItem = async (id: number): Promise<void> => {
  await apiClient.delete(`/campaign_groups/${id}`)
}

export const fetchStats = async (
  dateFrom: string,
  dateTo: string,
  groupIds?: number[]
): Promise<Record<string, ICampaignGroupStats>> => {
  const params: Record<string, any> = {
    date_from: dateFrom,
    date_to: dateTo
  }
  if (groupIds && groupIds.length > 0) {
    params.group_ids = groupIds
  }
  const response = await apiClient.get<Record<string, ICampaignGroupStats>>(
    '/campaign_groups/stats',
    { params }
  )
  return response.data
}

export const downloadCsvReport = async (
  id: number,
  dateFrom: string,
  dateTo: string
): Promise<Blob> => {
  const response = await apiClient.get(`/campaign_groups/${id}/csv_report`, {
    params: { date_from: dateFrom, date_to: dateTo },
    responseType: 'blob'
  })
  return response.data
}

export const searchCampaigns = async (
  query: string
): Promise<ISearchCampaignsResponse> => {
  const params = query
    ? nestedQueryFormatter('filter', { name__or__id: query }, false)
    : {}
  const response = await apiClient.get<ISearchCampaignsResponse>(
    '/campaign_groups/search_campaigns',
    { params }
  )
  return response.data
}
